import { Route } from '@angular/router';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../sb-routing-enum';
import { generatedReport } from './generatedReports';

export const standardReporting: Route = {
  path: 'standardReporting',
  title: 'nav.reporting.standardReporting',
  data: {
    icon: SbIcons.pieChartSettings,
    breadcrumb: 'nav.reporting.standardReporting',
  },
  children: [generatedReport, { path: '', redirectTo: RoutingID.generatedReport, pathMatch: 'full' }],
};
